(() => {
  if (!customElements.get('elura-proof-gallery')) {
    customElements.define('elura-proof-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.cards = [...this.querySelectorAll('[data-result]')];
        this.buttons = [...this.querySelectorAll('[data-filter-group] button')];
        this.select = this.querySelector('[data-focus]');
        this.more = this.querySelector('[data-more]');
        this.count = this.querySelector('[data-count]');
        this.product = 'all';
        this.focus = 'all';
        this.pageSize = Math.max(1, Number(this.dataset.pageSize) || 6);
        this.limit = this.pageSize;
        this.querySelector('[data-filter-group]').hidden = this.buttons.length < 2;
        this.buttons.forEach(button => button.addEventListener('click', () => {
          this.product = button.dataset.product;
          this.focus = 'all';
          this.limit = this.pageSize;
          this.setFocusOptions();
          this.update();
        }));
        this.select.addEventListener('change', () => {
          this.focus = this.select.value;
          this.limit = this.pageSize;
          this.update();
        });
        this.more.addEventListener('click', () => {
          const oldLimit = this.limit;
          this.limit += this.pageSize;
          this.update();
          const nextCard = this.filtered[oldLimit];
          if (nextCard) {
            nextCard.setAttribute('tabindex', '-1');
            nextCard.focus({ preventScroll: true });
          }
        });
        this.onBlock = event => {
          const card = event.target.closest('[data-result]');
          if (!card || !this.contains(card)) return;
          this.product = 'all';
          this.focus = 'all';
          this.limit = this.cards.length;
          this.setFocusOptions();
          this.update();
        };
        this.addEventListener('shopify:block:select', this.onBlock);
        this.setFocusOptions();
        this.update();
      }
      setFocusOptions() {
        const options = [...new Set(this.cards.filter(card => this.product === 'all' || card.dataset.product === this.product).map(card => card.dataset.focus.trim()).filter(Boolean))];
        while (this.select.options.length > 1) this.select.remove(1);
        options.forEach(label => this.select.add(new Option(label, label)));
        this.select.value = 'all';
        this.querySelector('[data-focus-wrap]').hidden = options.length < 2;
      }
      update() {
        this.filtered = this.cards.filter(card => (this.product === 'all' || card.dataset.product === this.product) && (this.focus === 'all' || card.dataset.focus.trim() === this.focus));
        const visible = new Set(this.filtered.slice(0, this.limit));
        this.cards.forEach(card => { card.hidden = !visible.has(card); });
        this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.product === this.product)));
        this.more.hidden = this.limit >= this.filtered.length;
        this.querySelector('[data-empty]').hidden = this.filtered.length !== 0;
        this.count.textContent = `${visible.size} / ${this.filtered.length} ${this.count.dataset.countLabel}`;
      }
    });
  }
  if (!customElements.get('elura-proof-reviews')) {
    customElements.define('elura-proof-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const select = this.querySelector('[data-review-filter]');
        const cards = [...this.querySelectorAll('[data-review]')];
        this.querySelector('[data-review-filter-wrap]').hidden = select.options.length < 3;
        const update = () => cards.forEach(card => { card.hidden = select.value !== 'all' && card.dataset.product !== select.value; });
        select.addEventListener('change', update);
        this.addEventListener('shopify:block:select', () => { select.value = 'all'; update(); });
        update();
      }
    });
  }
  if (!customElements.get('elura-proof-carousel')) {
    customElements.define('elura-proof-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          if (this.observer) this.observer.observe(this.track);
          this.update();
          return;
        }
        this.initialized = true;
        this.track = this.querySelector('[data-track]');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.controls = this.querySelector('[data-controls]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.position = this.querySelector('[data-position]');
        this.update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          this.controls.hidden = max < 4;
          this.prev.disabled = this.track.scrollLeft <= 2;
          this.next.disabled = this.track.scrollLeft >= max - 2;
          const step = this.slides[1] ? this.slides[1].offsetLeft - this.slides[0].offsetLeft : this.track.clientWidth;
          const index = Math.round(this.track.scrollLeft / Math.max(step, 1));
          this.position.textContent = `${Math.min(index + 1, this.slides.length)} / ${this.slides.length}`;
        };
        const move = direction => {
          const step = this.slides[1] ? this.slides[1].offsetLeft - this.slides[0].offsetLeft : this.track.clientWidth;
          this.track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        this.prev.addEventListener('click', () => move(-1));
        this.next.addEventListener('click', () => move(1));
        this.track.addEventListener('scroll', this.update, { passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          }
        });
        this.addEventListener('shopify:block:select', event => {
          const slide = event.target.closest('[data-slide]');
          if (slide) this.track.scrollTo({ left: slide.offsetLeft - this.slides[0].offsetLeft, behavior: 'auto' });
        });
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.track);
        this.update();
      }
      disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
    });
  }
})();
